import { link } from "@/components/Action.tsx";
import type { DiskWithPrice, DiskWithType } from "@/modules/disks/disksListQuery.ts";

export function diskLink({ location, uuid }: DiskWithPrice | DiskWithType) {
    return link({ to: "/disks/disk/$location/$uuid", params: { location, uuid } });
}
